export default __webpack_public_path__ + "static/media/og_image.1b9bcd73.jpg";